// Choix du thème de couleurs. Le thème de référence est enregistré côté
// backend (préférences utilisateur, donc il suit le compte), mais il est aussi
// recopié en localStorage : au démarrage, les préférences ne sont pas encore
// arrivées, et sans ce miroir la page s'afficherait une seconde en sombre
// avant de basculer.
//
// Appliquer un thème = poser `data-theme` sur <html>. Tout le reste est du CSS
// (voir la section THÈMES dans App.css).
//
// Dans l'app native (pas sur le web), la couleur/le style de la barre de
// statut Android suit aussi le thème : `capacitor.config.ts` ne pose que des
// valeurs par défaut (thème sombre) au tout premier lancement, c'est ICI
// qu'on la resynchronise à chaque changement de thème (et au démarrage), sinon
// elle resterait sombre même en passant au thème clair "Crème".
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

const STORAGE_KEY = "poketracker_theme";

export const THEMES = [
  { id: "dark", label: "Sombre", hint: "Le thème d'origine", swatch: ["#09090b", "#27272a", "#ef4444"] },
  { id: "julith", label: "Julith", hint: "Lie-de-vin et bleu nuit", swatch: ["#0a0c18", "#222842", "#b02a54"] },
  { id: "creme", label: "Crème", hint: "Clair : crème, brun et vert", swatch: ["#f7f2e6", "#ded3ba", "#3c703e"] },
];

const KNOWN = new Set(THEMES.map(t => t.id));
const swatchOf = (id) => THEMES.find(t => t.id === id)?.swatch[0] || "#09090b";

// `overlaysWebView: false` (posé une fois par capacitor.config.ts) fait déjà
// réserver la place de la barre par le système - ce qui reste à faire ici,
// c'est juste sa COULEUR : fond = même teinte que `--n-950` du thème actif
// (1er swatch de THEMES, déjà la référence de fond de chaque thème), icônes
// claires sur fond sombre ("Light") sauf pour "Crème" (fond clair -> icônes
// sombres, "Dark"). Ignoré silencieusement sur le web (pas de plugin natif).
function syncNativeStatusBar(id) {
  if (!Capacitor.isNativePlatform()) return;
  StatusBar.setBackgroundColor({ color: swatchOf(id) }).catch(() => {});
  StatusBar.setStyle({ style: id === "creme" ? Style.Dark : Style.Light }).catch(() => {});
}

export function applyTheme(theme) {
  const id = KNOWN.has(theme) ? theme : "dark";
  document.documentElement.setAttribute("data-theme", id);
  try { localStorage.setItem(STORAGE_KEY, id); } catch { /* mode privé */ }
  syncNativeStatusBar(id);
}

// À appeler le plus tôt possible (avant le premier rendu).
export function applyStoredTheme() {
  let stored = null;
  try { stored = localStorage.getItem(STORAGE_KEY); } catch { /* mode privé */ }
  const id = KNOWN.has(stored) ? stored : "dark";
  document.documentElement.setAttribute("data-theme", id);
  syncNativeStatusBar(id);
}
